import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// actions
import {
  currencyApiResponseSuccess,
  currencyApiResponseError,
  getCurrency,
} from "./actions";

// constants
import { CurrencyActionTypes } from "./constants";
import {
  addCurrencyApi,
  deleteCurrencyApi,
  getCurrencyApi,
  updateCurrencyApi,
} from "../../helpers/api/currency";

interface currencyData {
  payload: {
    id: number;
    currency_name: string | null;
    currency_flag: string | null;
    currency_code: string | null;
    currency_rate: string | null;
    isActive: any | null;
  };
  type: string;
}

function* createCurrency({
  payload: { currency_name, currency_flag, currency_code, currency_rate },
  type,
}: currencyData): SagaIterator {
  try {
    const response = yield call(addCurrencyApi, {
      currency_name,
      currency_flag,
      currency_code,
      currency_rate,
    });
    

    const currencyData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      currencyApiResponseSuccess(
        CurrencyActionTypes.CREATE_CURRENCY,
        currencyData
      )
    );
    yield put(getCurrency());
  } catch (error: any) {
    yield put(
      currencyApiResponseError(CurrencyActionTypes.CREATE_CURRENCY, error)
    );
  }
}

function* updateCurrency({
  payload: {
    id,
    currency_name,
    currency_flag,
    currency_code,
    currency_rate,
    isActive,
  },
}: currencyData): SagaIterator {
  try {
    const response = yield call(updateCurrencyApi, id, {
      currency_name,
      currency_flag,
      currency_code,
      currency_rate,
      isActive,
    });
    const currencyData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      currencyApiResponseSuccess(
        CurrencyActionTypes.UPDATE_CURRENCY,
        currencyData
      )
    );
    yield put(getCurrency());
  } catch (error: any) {
    yield put(
      currencyApiResponseError(CurrencyActionTypes.UPDATE_CURRENCY, error)
    );
  }
}

function* getCurrencies(): SagaIterator {
  try {
    const response = yield call(getCurrencyApi);
    const currencyData = response?.data?.currencies;

    yield put(
      currencyApiResponseSuccess(CurrencyActionTypes.GET_CURRENCY, currencyData)
    );
  } catch (error: any) {
    yield put(
      currencyApiResponseError(CurrencyActionTypes.GET_CURRENCY, error)
    );
  }
}

function* deleteCurrency({ payload: { id } }: currencyData): SagaIterator {
  try {
    const response = yield call(deleteCurrencyApi, id);
    const currencyData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      currencyApiResponseSuccess(
        CurrencyActionTypes.DELETE_CURRENCY,
        currencyData
      )
    );
    yield put(getCurrency());
  } catch (error: any) {
    yield put(
      currencyApiResponseError(CurrencyActionTypes.DELETE_CURRENCY, error)
    );
  }
}

export function* watchCreateCurrency() {
  yield takeEvery(CurrencyActionTypes.CREATE_CURRENCY, createCurrency);
}
export function* watchUpdateCurrency() {
  yield takeEvery(CurrencyActionTypes.UPDATE_CURRENCY, updateCurrency);
}
export function* watchGetCurrency() {
  yield takeEvery(CurrencyActionTypes.GET_CURRENCY, getCurrencies);
}

export function* watchDeleteCurrency() {
  yield takeEvery(CurrencyActionTypes.DELETE_CURRENCY, deleteCurrency);
}

function* currencySaga() {
  yield all([
    fork(watchCreateCurrency),
    fork(watchUpdateCurrency),
    fork(watchDeleteCurrency),
    fork(watchGetCurrency),
  ]);
}

export default currencySaga;
